import { UserModel } from '@/models/UserModel';

export const buildProductTourFacilityMetadata = (user: UserModel) => ({
  facility_id: user.facility_id ?? undefined,
  facility_name: user.user_facility_accesses?.find(
    (facilityAccess) => facilityAccess.facility_id === user.facility_id
  )?.facility?.name
});
